import React from 'react';
import Gnb from './Gnb';
import Top from './Top';

const Header: React.FC = () => {
    return (
        <header id="header">
            <Top />
            <Gnb />
        </header>
    )
}

export default Header;